
import { defineComponent, ref, PropType } from "vue";
import { ElTable } from "element-plus";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { Estimation } from "@/types/estimation.type";
import { Parameter } from "@/types/parameter.type";
import SamplingPointImageComponent from "./SamplingPointImage.component.vue";
import SamplingPointImageModalComponent from "./SamplingPointImageModal.component.vue";
import ModalInfoEstimationsYesterday from "@/components/modalInfoEstimationsYesterday.component.vue";
import securityService from "@/service/security.service";
import { AppRole } from "@/types/app.type";
import { OpticalAndLevel } from "@/types/opticalAndLevel.type";
import { getOpticalAndLevelsBySamplingPoint } from "@/service/opticalAndLevel.service";

interface ParameterTable extends Estimation {
  name?: string;
  colour?: string;
  tmoa?: string;
}

export default defineComponent({
  components: {
    SamplingPointImageComponent,
    SamplingPointImageModalComponent,
    ModalInfoEstimationsYesterday,
  },
  props: {
    defaultParameter: {
      type: Object,
      required: false,
    },
    samplingPoint: {
      type: Object as PropType<SamplingPoint>,
      required: false,
    },
    image: {
      type: Object,
      required: false,
    },
    data: {
      type: Object as PropType<ParameterTable[]>,
      required: false,
    },
    onParameterClick: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const isAppDemo = securityService.hasRole(AppRole.DEMOS) ? true : false;

    return { isAppDemo };
  },
  data() {
    return {
      entorno: false,
      selectedParameter: {} as Parameter,
      singleTableRef: ref<InstanceType<typeof ElTable>>(),
      currentRow: ref(),
      isModalImageVisible: false,
      isModalEstimationsYesterdayVisible: false,
      datosParametros: {} as any,
      dialogInfoTrendVisible: false,
      paramsVisible: true,
      childLoading: true,
      toggleLock: true,
      opticalAndLevels: [] as OpticalAndLevel[],
    };
  },

  async mounted() {
    // Control de entorno
    this.entorno = process.env.NODE_ENV === "pre" || process.env.NODE_ENV === "development";

    if (this.samplingPoint?.id) {
      this.opticalAndLevels = await getOpticalAndLevelsBySamplingPoint(this.samplingPoint.id);
    }

    this.selectedParameter = Object.assign({} as Parameter, this.defaultParameter);

    setTimeout(() => {
      this.toggleLock = false;
    }, 3000);
  },

  methods: {
    toggleVisibility() {
      if (this.childLoading) return;
      if (this.toggleLock) return;

      this.toggleLock = true;
      this.paramsVisible = !this.paramsVisible;

      setTimeout(() => {
        this.toggleLock = false;
      }, 300);
    },
    visualiceModalEstimtionYesterday() {
      this.isModalEstimationsYesterdayVisible = true;
      this.datosParametros = this.data;
    },
    closeModalImage() {
      this.isModalImageVisible = false;
    },
    seeImages() {
      if (this.samplingPoint?.id) {
        this.isModalImageVisible = true;
      }
    },
    dialogInfoTrendOpen() {
      this.dialogInfoTrendVisible = true;
    },

    goToTMOA() {
      if (this.samplingPoint?.id) {
        this.$router.push({
          path: `/support/samplingPoints/tmoa/${this.samplingPoint.id}`,
          query: { samplingPoint: this.samplingPoint.id },
        });
      }
    },

    tableRowClassName(obj: { row: ParameterTable; rowIndex: number }) {
      if (obj.row.parameter === this.defaultParameter) {
        return "selected-row";
      } else {
        return "";
      }
    },

    onClick(parameter: Parameter | undefined) {
      var row = document.getElementsByClassName("selected-row");

      if (row[0]) {
        row[0].className = row[0].className.replace("selected-row", "");
      }

      if (parameter && parameter.code !== "ALT") {
        if (parameter) {
          this.onParameterClick(parameter);
        }
      }
    },

    orderParameterByName(dataArray: any[] | undefined) {
      if (!dataArray) {
        console.log("Sin Datos");
        return [];
      }

      const order = [
        "Estado",
        "Turbidez",
        "Sólidos en Suspensión",
        "Sólidos disueltos",
        "MES",
        "Conductividad",
        "REDOX",
        "DQO",
        "DBO5 | DBO",
        "DBO",
        "Demanda química de oxígeno",
        "Carbono Orgánico Disuelto",
        "Carbono orgánico disuelto (COD)",
        "COD",
        "COT",
        "Carbono Orgánico Total",
        "Nitrógeno Total",
        "Nitrógeno",
        "Nitrato",
        "Oxígeno Disuelto",
        "pH",
        "Fósforo",
        "Fosfato",
        "Ortofosfato",
        "Amonio",
        "Hierro",
        "Manganeso",
        "Aceites y grasas",
        "Espumas",
        "Lentejas",
        "Retorno",
        "Color",
        "Algas verdeazuladas",
        "Algas verdes",
        "Clorofila A (algas verdeazuladas)",
        "Clorofila A (algas verdes)",
        "Clorofila A (diatomeas)",
        "Clorofila A (cryptophytas)",
        "Clorofila A total",
        "Cryptophytas (control de algas superficie)",
        "Diatomeas (control de algas superficie)",
        "Total algas (control de algas superficie)",
        "Nivel",
        "E.coli",
      ];

      return dataArray.sort((a, b) => {
        const nameA = a.parameter?.name?.toLowerCase();
        const nameB = b.parameter?.name?.toLowerCase();

        if (!nameA || !nameB) {
          return 0;
        }

        const indexA = order.findIndex((item) => item.toLowerCase() === nameA);
        const indexB = order.findIndex((item) => item.toLowerCase() === nameB);

        if (indexA === -1 && indexB === -1) {
          return 0;
        }
        if (indexA === -1) {
          return 1;
        }
        if (indexB === -1) {
          return -1;
        }

        return indexA - indexB;
      });
    },

    getOpticalAndLevelName(parameterId: number | undefined, value: unknown) {
      const record = this.opticalAndLevels.find(
        (item) =>
          Number(item.parameter?.id) === Number(parameterId) && Number(item.value) === Number(value)
      );

      return record?.name || "-";
    },
  },
  watch: {
    samplingPoint: {
      immediate: true,
      async handler(value) {
        if (value?.id) {
          this.opticalAndLevels = await getOpticalAndLevelsBySamplingPoint(value.id);
        }
      },
    },
  },
});
